import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomerSmartApp } from '../../../core/models/smart-app.model';

@Component({
  selector: 'cm-smart-app-launch-selector',
  templateUrl: './smart-app-launch-selector.component.html',
  styleUrls: ['./smart-app-launch-selector.component.scss'],
})
export class SmartAppLaunchSelectorComponent {
  @Input() apps: CustomerSmartApp[] = [];
  @Input() launchAppId: number | null = null;
  @Output() launchAppIdChange = new EventEmitter<number | null>();

  onSelect(id: number | null): void {
    this.launchAppId = id;
    this.launchAppIdChange.emit(id);
  }
}
